export class AnimationContent {
}
